import { DocumentWithUser } from '@snap-types/models/document';
import invariant from 'tiny-invariant';

import { WritableConfiguratorStoreState } from '../../types';
import { ConfiguratorAction } from './types';

export type AttachOperationDocumentAction = ConfiguratorAction<
  'attachDocument',
  { stepId: string; document: DocumentWithUser }
>;

export const attachOperationDocument = (
  stepId: string,
  document: DocumentWithUser,
): AttachOperationDocumentAction => ({
  type: 'attachDocument',
  payload: {
    stepId,
    document,
  },
});

export function attachOperationDocumentAction(
  state: WritableConfiguratorStoreState,
  document: DocumentWithUser,
  stepId: string,
) {
  const operation = state.blueprint.operations.find(
    (operation) => operation.stepId === stepId,
  );

  invariant(operation, 'Operation not found');

  operation.documents = [...(operation.documents ?? []), document];
}
